import React from 'react';
import { 
    TextField, 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem, 
    FormControlLabel, 
    Switch,
    Box,
    Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const BasicInfo = ({ basicInfo, setBasicInfo, locList, user, edit }) => {
    
    const handleChange = (field, value) => {
        setBasicInfo(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <Box sx={{ p: 3 }}>
            <TextField
                required
                fullWidth
                label="Household Name"
                value={basicInfo.household_name}
                onChange={(e) => handleChange('household_name', e.target.value)}
                placeholder="e.g., Smith Family Household"
                helperText="A descriptive name for this household"
                sx={{ mb: 3 }}
            />

            <TextField
                fullWidth
                multiline
                rows={4}
                label="Description"
                value={basicInfo.household_description}
                onChange={(e) => handleChange('household_description', e.target.value)}
                placeholder="Additional details about this household..."
                helperText="Optional: Add any relevant information about the household"
                sx={{ mb: 3 }}
            />

            <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                <FormControl sx={{ flex: 1 }}>
                    <InputLabel>Location</InputLabel>
                    <Select
                        value={basicInfo.loc_id || ''}
                        onChange={(e) => handleChange('loc_id', e.target.value)}
                        label="Location"
                    >
                        <MenuItem value="">
                            <em>No Location</em>
                        </MenuItem>
                        {locList
                            .filter(loc => loc.loc_is_active)
                            .map((loc) => (
                                <MenuItem key={loc.loc_id} value={loc.loc_id}>
                                    {`${loc.loc_addr_line1}${loc.loc_addr_line2 ? ' ' + loc.loc_addr_line2 : ''}, ${loc.loc_city}, ${loc.loc_state} ${loc.loc_zip}`}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="Last Visited Date"
                        value={basicInfo.date_last_visited ? dayjs(basicInfo.date_last_visited) : null}
                        onChange={(newValue) => {
                            handleChange('date_last_visited', newValue ? dayjs(newValue).format('YYYY-MM-DD') : null);
                        }}
                        slotProps={{
                            textField: {
                                helperText: 'Optional: Last date this household was visited'
                            }
                        }}
                        sx={{ flex: 1 }}
                    />
                </LocalizationProvider>
            </Box>

            <FormControlLabel
                control={
                    <Switch
                        checked={basicInfo.is_actively_serviced}
                        onChange={(e) => handleChange('is_actively_serviced', e.target.checked)}
                        color="primary"
                    />
                }
                label={
                    <Box>
                        <Typography variant="body1">
                            {basicInfo.is_actively_serviced ? 'Active' : 'Inactive'}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                            Is this household actively being serviced?
                        </Typography>
                    </Box>
                }
                sx={{ mb: 3 }}
            />

            {edit && basicInfo.date_added && (
                <Box sx={{ p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
                    <Typography variant="caption" color="textSecondary">
                        Created: {dayjs(basicInfo.date_added).format('MMM DD, YYYY')}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default BasicInfo;
